module.exports = __webpack_public_path__ + "static/media/logo-purple.2f69636d.png";